
import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import '../candidateProfiles/CandidateProfiles.css';
import { useCandidateGridDatasMutation, useDeleteEventHistoryMutation, usePositionDropdownMutation, useSelectedJobPositionMutation, useViewAllReferralCandidateMutation, useViewCandidateHistoryMutation } from '../../redux/candidateprofiles/candidateprofiles.api';
import { useSelector } from 'react-redux';
import { useEffect, useState, useContext } from 'react';
import { Avatar, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, InputAdornment, InputLabel, ListItemText, MenuItem, Pagination, Select, Stack, Tooltip, Typography } from '@mui/material';
import MUIButton from '../../reusable_components/components/MUIButton';
import DeleteIcon from '../../assets/Icons/DeleteIcon'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MuiButton from '../../reusable_components/components/MUIButton';
import { useNavigate } from 'react-router-dom';
import MUICancelButton from '../../reusable_components/components/MuiCancelButton';
import { SnackbarContext } from '../../reusable_components/components/Snackbar';
import { TableLoader } from '../../reusable_components/components/TableLoader';
import ReplayIcon from '@mui/icons-material/Replay';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AddIcon from '@mui/icons-material/Add';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import ArrowDownwardSharpIcon from '@mui/icons-material/ArrowDownwardSharp';
import ArrowUpwardSharpIcon from '@mui/icons-material/ArrowUpwardSharp';
// import DatePicker from "react-datepicker";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIconLg from "../../assets/Icons/SearchIcon";
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import MuiDatePicker from '../../reusable_components/components/MuiDatePicker';

const CandidateReferrals = ({ search }) => {

  const navigate = useNavigate();
  const { Snackbar } = useContext(SnackbarContext)


  // API calling
  const [TableDatas] = useViewAllReferralCandidateMutation()
  const [viewcandidateHistory] = useViewCandidateHistoryMutation()
  const [addJobPostion] = usePositionDropdownMutation()
  const [selectedJobPosition] = useSelectedJobPositionMutation()
  const [deleteHistory] = useDeleteEventHistoryMutation()

  const [candidatesDatas, setCandidatesDatas] = useState([])
  const [candidateHistory, setCandiateHistory] = useState([])
  const [positions, setPositions] = useState([])
  const [selectedPositionIds, setSelectedPositionIds] = useState([])
  const [count, setCount] = useState(0)
  const [positionNames, setPositionNames] = useState([])

  const { Profile } = useSelector((state) => state.common)
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [search, setSearch] = useState('');
  const [profileId, setProfileId] = useState('')
  const [location, setLocation] = useState("")
  const [technologies, setTechnologies] = useState("")
  const [mobile, setMobile] = useState("")
  const [email, setEmail] = useState("")
  const [sourcedBy, setSourcedBy] = useState()
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [sortingColumnDirection, setSortingColumnDirection] = useState('')
  const [arrow, setArrow] = useState(false)
  const [filter, setFillter] = useState(false)
  const [showTableLoader, setShowTableLoader] = useState(false)
  const [historytableLoder, setHistorytableLoder] = useState(false)
  const [showClearFilter, setShowClearFilter] = useState(false)
  const [triggerApi, setTriggerApi] = useState(false)

  // dialog box properties...
  const [open, setOpen] = useState(false);
  const [openpostions, setoPenPostions] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setHistorytableLoder(false)
  }

  // for filter dialog box open
  const handleCloseFilterDialog = () => setFilterDialogOpen(false)
  const [filterDialogOpen, setFilterDialogOpen] = useState(false)

  // const onchangesearchbar = (event) => {
  //   setSearch(event.target.value)
  // }

  const handleOpenFillterDialog = () => {
    if (chips.length === 0) {
      setTechnologies("")
      setMobile("")
      setLocation("")
      setEmail("")
      setFromDate(null)
      setToDate(null)
      setSourcedBy("")
      setTriggerApi(true)
      setShowClearFilter(false)
      setFilterDialogOpen(true)
    } else {
      setFilterDialogOpen(true)
    }
  }

  const handleGetLocation = (e) => {
    setLocation(e.target.value)
  }


  const handleTechnologies = (e) => {
    setTechnologies(e.target.value)

  }

  const handleMobile = (e) => {
    setMobile(e.target.value)
  }

  const handleEmail = (e) => {
    setEmail(e.target.value)
  }

  const handleSourcedBy = (e) => {
    setSourcedBy(e.target.value)
  }

  const hanldeFromDate = (value) => {
    if (toDate && toDate <= value) {
      setToDate(null)
    }
    setFromDate(value);
  }

  const handleTodate = (value) => {
    setToDate(value);
  }

  const getNextDay = (fromDate) => {
    if (!fromDate) {
      return null
    }
    return dayjs(fromDate)?.add(1, 'day')
  }

  const handleSorting = (e) => {
    if (!arrow) {
      setSortingColumnDirection('DESC')
      setArrow(true)
      setTriggerApi(true)
    } else {
      setSortingColumnDirection('')
      setArrow(false)
      setTriggerApi(true)
    }
  }

  const [searchQuery, setSearchQuery] = useState('');

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter positions based on the search query
  const filteredPositions = positions?.response?.filter((position) =>
    position.listData.toLowerCase().includes(searchQuery.toLowerCase()) ||
    position.positionDesc.toLowerCase().includes(searchQuery.toLowerCase())

  );

  const handleCheckboxChange = (event, positionId) => {
    const newSelectedIds = event.target.checked
      ? [...selectedPositionIds, positionId]  // Add the id if checked
      : selectedPositionIds.filter((id) => id !== positionId);  // Remove if unchecked
    setSelectedPositionIds(newSelectedIds);
  };

  const addJob = async () => {
    try {
      const payload = {
        clientName: "",
        positionTitle: "",
        candiateId: profileId
      }

      const response = await addJobPostion(payload)?.unwrap()
      setPositions(response);
    } catch (error) {
      Snackbar("Network error", 'error')
    }
  }

  const assignPositions = async () => {
    try {
      if (selectedPositionIds.length > 0) {
        const payload = {
          profileId: profileId,
          position: selectedPositionIds
        }

        const response = await selectedJobPosition(payload).unwrap()
        Snackbar(response?.response?.message, 'success')
        handleClosePosition()
        setSelectedPositionIds([])
        setSearchQuery("")
      }

    } catch (error) {
      Snackbar("Network error", 'error')
    }
  }

  const getTableDatas = async () => {
    try {
      const params = {
        // sortingColumn: "",
        sortingDirection: sortingColumnDirection || "",
        address: location,
        technologies: technologies,
        mobileOrAlternateMobile: mobile,
        emailOrAlternateEmail: email,
        sourceBy: sourcedBy,
        firstNameOrLastName: search,
        fromDate: fromDate ? dayjs(fromDate)?.format('YYYY-MM-DD') : '',
        toDate: toDate ? dayjs(toDate)?.format('YYYY-MM-DD') : '',
        page: page ? page - 1 : 0,
        size: rowsPerPage ? rowsPerPage : 10,
      }
      setShowTableLoader(true);
      const response = await TableDatas(params).unwrap()

      setShowTableLoader(false);
      setCandidatesDatas(response.response?.data);
      setCount(response?.response?.Count);

    } catch (err) {
      Snackbar("Network failed", 'error')
      setShowTableLoader(false);
    }
  }

  const [chips, setChips] = useState([])

  const letsFilterDatas = () => {

    const updateChip = ([
      {
        label: location,
        onDelete: () => {
          setLocation("")
          setTriggerApi(true)
          setChips(prevChips => prevChips?.filter(chips => chips?.label !== location))
        }
      },
      {
        label: technologies,
        onDelete: () => {
          setTechnologies("")
          setTriggerApi(true)
          setChips(prevChips => prevChips?.filter(chips => chips?.label !== technologies))
        }
      },
      {
        label: mobile,
        onDelete: () => {
          setMobile("")
          setTriggerApi(true)
          setChips(prevChips => prevChips?.filter(chips => chips?.label !== mobile))

        }
      },
      {
        label: email,
        onDelete: () => {
          setEmail("")
          setTriggerApi(true)
          setChips(prevChips => prevChips?.filter(chips => chips?.label !== email))
        }
      },
      fromDate && {
        label: fromDate ? dayjs(fromDate)?.format('DD-MM-YYYY') : '',
        onDelete: () => {
          setFromDate("")
          setTriggerApi(true)
          setToDate("")
          setChips(prevChips => prevChips?.filter(chips => chips?.label !== dayjs(fromDate)?.format('DD-MM-YYYY')))

        }
      },
      toDate && {
        label: toDate ? dayjs(toDate)?.format('DD-MM-YYYY') : '',
        onDelete: () => {
          setToDate("")
          setTriggerApi(true)
          setChips(prevChips => prevChips?.filter(chips => chips?.label !== dayjs(toDate)?.format('DD-MM-YYYY')))
        }
      },
      {
        label: sourcedBy,
        onDelete: () => {
          setSourcedBy("")
          setTriggerApi(true)
          setChips(prevChips => prevChips?.filter(chips => chips?.label !== sourcedBy))
        }
      },
    ]).filter(Boolean)

    setChips(updateChip)
    setTriggerApi(true)
    setShowClearFilter(true)
  }

  useEffect(() => {
    getTableDatas()
  }, [search])

  useEffect(() => {
    if (triggerApi) {
      getTableDatas()
      handleCloseFilterDialog()
      setTriggerApi(false)
    }
  }, [TableDatas, rowsPerPage, page, search, sortingColumnDirection, triggerApi])


  // Navigations
  const manage_Events = (row) => {
    navigate(`/referrals/manage-events-candidate/${row?.profileId}`, {
      state: { profileId: row?.profileId, firstName: row.firstName, lastName: row.lastName, email: row.email, mobile: row.mobile, remarks: row.remarks, isReferrals: true }
    });
  };

  const handleCandidateNav = (row) => {
    navigate(`/referrals/editcandidateprofile/${row.profileId}`, {
      state: {
        isReferrals: true
      }
    })
  }

  const handleAddCandidateNav = () => {
    navigate('/addcandidateprofile')
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setTriggerApi(true)
  };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const viewHistory = async (profileId) => {
    setOpen(true);
    try {
      const payload = {
        profileId: profileId,
        positionId: 0,
        page: page - 1,
        size: 5000
      }
      const response = await viewcandidateHistory(payload)?.unwrap()
      if (response) {
        setCandiateHistory(response?.response?.eventHistory)
        setHistorytableLoder(true)
      }
    } catch (error) {
      Snackbar("Network error", 'error')
    }
  }

  const addPosition = (profileId) => {
    setoPenPostions(true)
    setProfileId(profileId)
  }

  const handlePositionId = (positionId) => {
    setSelectedPositionIds((prevSelected) =>
      prevSelected?.includes(positionId)
        ? prevSelected?.filter((id) => id !== positionId)
        : [...prevSelected, positionId]
    )
  }

  useEffect(() => {
    const positionNames = positions?.response?.filter((item) =>
      selectedPositionIds?.includes(item?.positionId)
    )
    setPositionNames(positionNames)

  }, [selectedPositionIds, positions])


  const handleClosePosition = () => {
    setoPenPostions(false);
  }


  const [MinihistoryDialogOpen, setMinihistoryDialogOpen] = useState(false)
  const [deleteId, setDeleteId] = useState([])
  const [profileMatchId, setProfileMatchId] = useState()
  const [isDelete, setIsDelete] = useState(false)

  const handleCloseDelete = () => {
    setMinihistoryDialogOpen(false)
  }

  const hanldeMiniDialogOpen = (item) => {
    setMinihistoryDialogOpen(true)
    setProfileMatchId(item?.profileMatchId)
    setDeleteId(item?.eventHistoryId)
    setIsDelete(item?.deletable)
  }

  const deleteEventHistory = async (item) => {
    if (isDelete === true) {
      try {
        const payload = {
          eventHistoryIds: [deleteId] || [],
          profileMatchId: profileMatchId // Use 0 as default if profileMatchId is missing
        };

        const response = await deleteHistory(payload).unwrap()
        setMinihistoryDialogOpen(false)
        setOpen(false)

        Snackbar(response?.response?.message, 'success')
      } catch (error) {
        Snackbar("Network error", 'error')
      }
    } else {
      Snackbar("Network error", "error")
    }
  }

  const formatDate = (date = new Date()) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleclearFilterState = () => {
    setTechnologies("")
    setMobile("")
    setLocation("")
    setEmail("")
    setFromDate(null)
    setToDate(null)
    setSourcedBy("")
    setTriggerApi(true)
    setShowClearFilter(false)
  }

  useEffect(() => {
    if (profileId) {
      addJob();
    }

  }, [openpostions])

  useEffect(() => {
    if (positions?.response) {
      const selectedJObId = positions.response.filter((id) => id?.hasSelected);
      const ids = selectedJObId?.map((id) => id?.positionId);
      setSelectedPositionIds(ids);
    }
  }, [positions]);


  useEffect(() => {
    if (chips?.every((name) => !name?.label)) {
      setShowClearFilter(false)
    }
  }, [triggerApi])

  return (
    <Box sx={{ marginTop: '20px' }}>

      {/* <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
        <Box>
          <Typography className='title'>Candidate Referrals</Typography>
        </Box>

        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{ display: 'flex', flexDirection: "row", gap: '20px' }}
        >
          <TextField
            placeholder="Search "
            className='textfields1'
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginRight: '5px' }}>
                    <SearchIconLg width={20} height={20} />
                  </InputAdornment>
                )
              }
            }}
            value={search}
            onChange={onchangesearchbar}
          />
        </Box>
      </Box> */}

      <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '10px', border: '1px solid #E9EAEB', borderRadius: '10px' }} elevation={0}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={100} sx={{ padding: '5px' }} >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    {showClearFilter && (
                      chips?.map((chip, index) => (
                        chip?.label && (
                          <Chip
                            variant="outlined"
                            size='small'
                            className='Chip'
                            key={index}
                            label={chip?.label}
                            deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                            onDelete={chip?.onDelete}
                          />
                        )
                      ))
                    )}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '14px' }}>
                    <MUICancelButton title='More Filters'
                      onClick={handleOpenFillterDialog}
                      startIcon={<FilterListOutlinedIcon sx={{ fontSize: '14px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                    {(location || technologies || mobile || email || fromDate || toDate || sourcedBy) && showClearFilter && (
                      <MUICancelButton title='Clear filter' onClick={handleclearFilterState} sx={{ width: '100px' }} />
                    )}
                  </div>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              {/* <TableCell className='tableHeadersCell_2' >Id</TableCell> */}
              <TableCell className='tableHeadersCell_2' onClick={handleSorting}>

                <Typography className='tableHeadersCell_2' sx={{ display: 'inline-flex', alignItems: 'center', fontSize: '14px', cursor: 'pointer' }}>Name
                  {
                    arrow ? (<ArrowDownwardSharpIcon sx={{ fontSize: '18px' }} />) : (
                      <ArrowUpwardSharpIcon sx={{ fontSize: '16px' }} />
                    )
                  }
                </Typography>


              </TableCell>
              <TableCell className='tableHeadersCell_2'>Location</TableCell>
              <TableCell className='tableHeadersCell_2'>Technologies</TableCell>
              <TableCell className='tableHeadersCell_2'>Phone / Alternate Phn </TableCell>
              <TableCell className='tableHeadersCell_2'>Email / Alternate Email </TableCell>
              <TableCell className='tableHeadersCell_2'>Sourced By</TableCell>
              <TableCell className='tableHeadersCell_2' align='center'>Created Date</TableCell>
              <TableCell className='tableHeadersCell_2' align='center'>Status</TableCell>
              {/* <TableCell className='tableHeadersCell_2' align='center'>Action</TableCell> */}

            </TableRow>
          </TableHead>
          {!showTableLoader ? (
            candidatesDatas?.length > 0 ? (
              <TableBody>
                {candidatesDatas?.map((row, index) => {
                  const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                  const backgroundColor = colors[index % colors?.length]
                  const techNames = row?.technologies?.map((item) => {
                    return (
                      item.itemName?.trim()
                    )
                  })
                  const twoTechs = techNames?.slice(0, 2)
                  const aboveTwoTechs = techNames?.slice(2)
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={row.code}
                      sx={{
                        backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                        '&:hover': { backgroundColor: '#f1f1f1' },
                      }}
                    >
                      {/* <TableCell onClick={() => handleCandidateNav(row)} className="tableBodyCell" sx={{ color: '#53389E', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' }} align='left'>{row.profileId}</TableCell> */}
                      <TableCell className='tableBodyCells' onClick={() => handleCandidateNav(row)} sx={{ cursor: 'pointer' }}>

                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                          <Typography sx={{ color: '#53389E', fontWeight: 'bold', fontSize: '14px' }}>{row?.firstName} {row?.lastName}</Typography>
                        </Box>

                      </TableCell>
                      <TableCell className='tableBodyCells' sx={{ color: "#181D27" }}>{row.address}</TableCell>
                      <TableCell className='tableBodyCells' sx={{ color: "#181D27" }}>
                        <Tooltip
                          slotProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#0A0D12",
                                borderRadius: '8px',
                                padding: '8px 12px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                              }
                            }
                          }}
                          title={aboveTwoTechs?.join(', ')} arrow placement='top'>
                          {aboveTwoTechs?.length > 0 ? `${twoTechs?.join(', ')} and ${aboveTwoTechs?.length} more` : twoTechs?.join(', ')}
                        </Tooltip>
                      </TableCell>
                      <TableCell className='tableBodyCells' sx={{ color: "#181D27", width: '14%' }}> {row.mobile}/<br />{row.alternateMobile || 'NA'}</TableCell>
                      <TableCell className='tableBodyCells' sx={{ color: "#181D27" }}> {row.email}/<br />{row.alternateEmail || 'NA'}</TableCell>
                      <TableCell className='tableBodyCells'>

                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                          <Avatar alt={row?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: backgroundColor, fontSize: '14px' }}>{row?.sourceName?.charAt(0)?.toUpperCase() || "?"}</Avatar>
                          <Typography className='tableBodyCells' sx={{ color: "#181D27" }}>{row?.sourceName}<br></br><span style={{ color: '#535862' }}>{row?.sourceBy}</span></Typography>
                        </Box>

                      </TableCell>
                      <TableCell className='tableBodyCells' sx={{ color: '#535862', width: '9%' }} align='center' > {formatDate(row.createdDate)}</TableCell>
                      <TableCell className="tableBodyCells">
                        <span className={`candidateStatus-badge ${row?.status?.toLowerCase()}`}>
                          {row.status === "Active"
                            ? "Approved"
                            : row.status === "Inactive"
                              ? "Rejected"
                              : row.status === "Pending"
                                ? "Pending"
                                : ""}
                        </span>
                      </TableCell>
                      {/* <TableCell className='tableBodyCells' sx={{ minWidth: '100px' }}>

                        <Tooltip title={row?.status === "Active" ? "History" : ""}
                          slotProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#0A0D12",
                                borderRadius: '8px',
                                padding: '8px 12px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
                              }
                            }
                          }}
                        >
                          <ReplayIcon className="icons" onClick={row?.status === "Active" ? () => viewHistory(row?.profileId) : null}
                            sx={{
                              fontSize: "17px ",
                              margin: '5px',
                              cursor: row?.status === "Active" ? 'pointer' : 'not-allowed',
                            }}
                          />
                        </Tooltip>

                        <Tooltip title={row?.status === "Active" ? "Add Job" : ""}
                          slotProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#0A0D12",
                                borderRadius: '8px',
                                padding: '8px 12px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                              }
                            }
                          }}
                        >
                          <CreateNewFolderOutlinedIcon className="icons" onClick={row?.status === "Active" ? () => addPosition(row.profileId) : null}
                            sx={{
                              fontSize: "17px",
                              margin: '5px',
                              cursor: row?.status === "Active" ? 'pointer' : 'not-allowed',
                            }} />
                        </Tooltip>

                        <Tooltip title={row?.status === "Active" ? "Manage Events" : ""}
                          slotProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#0A0D12",
                                borderRadius: '8px',
                                padding: '8px 12px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                              }
                            }
                          }}
                        >
                          <DescriptionOutlinedIcon className="icons" onClick={row?.status === "Active" ? () => manage_Events(row) : null}
                            sx={{
                              fontSize: "17px",
                              margin: '5px',
                              cursor: row?.status === "Active" ? 'pointer' : 'not-allowed',
                            }} />
                        </Tooltip>

                      </TableCell> */}
                    </TableRow>
                  );
                })}
              </TableBody>
            ) : (<TableBody>
              <TableRow>
                <TableCell colSpan={10}>
                  <Typography className="emptydatas">No Data Found</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
            )
          ) : (
            <TableRow>
              <TableCell colSpan={13}>
                <Box className='tableloader'>
                  <TableLoader />
                </Box>
              </TableCell>
            </TableRow>
          )}
          <TableRow>{count <= rowsPerPage ? ("") : (
            <TableCell colSpan={100}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <MUICancelButton
                  title='Previous'
                  startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                  disabled={page === 1}
                  onClick={() => handleChangePage(null, page - 1)}
                  sx={{ height: '36px' }}
                />
                <Pagination
                  page={page}
                  onChange={handleChangePage}
                  count={Math.ceil(count / rowsPerPage)}
                  siblingCount={3}
                  boundaryCount={3}
                  shape="rounded"
                  hidePrevButton
                  hideNextButton
                />

                <MUICancelButton
                  title='Next'
                  startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                  disabled={page === Math.ceil(count / rowsPerPage)}
                  onClick={() => handleChangePage(null, page + 1)}
                  sx={{ height: '36px' }}
                />

              </div>
            </TableCell>)
          }
          </TableRow>
        </Table>
      </Paper>

      <Grid2>
        <Dialog
          open={open}
          onClose={handleClose}
          scroll="paper"
          maxWidth="md"
          sx={{
            '& .MuiDialog-paper': {
              minHeight: '85vh',
              minWidth: '70vw'
            },
            marginLeft: '70px'
          }}
        >
          <DialogTitle variant="h6">
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '18px' }}>History</Typography>
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose}></CloseIcon>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <TableContainer>
              <Table>

                <TableHead>
                  <TableRow >
                    <TableCell className='tableHeadersCell'>Date </TableCell>
                    <TableCell className='tableHeadersCell'>Client Name </TableCell>
                    <TableCell className='tableHeadersCell'>Job Title </TableCell>
                    <TableCell className='tableHeadersCell'>Event </TableCell>
                    <TableCell className='tableHeadersCell'>Notes </TableCell>
                    <TableCell className='tableHeadersCell'>Processed By </TableCell>
                    <TableCell className='tableHeadersCell'>Action</TableCell>
                  </TableRow>
                </TableHead>
                {
                  historytableLoder ? (
                    candidateHistory.length > 0 ? (
                      <TableBody>

                        {
                          candidateHistory.map((item, index) => (
                            <TableRow key={index}
                              sx={{
                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                '&:hover': { backgroundColor: '#f1f1f1' },
                              }}
                            >
                              <TableCell className="tableBodyCell" >
                                {formatDate(item.date)}
                              </TableCell>
                              <TableCell className='tableBodyCell'
                              >
                                {item.clientName}
                              </TableCell >
                              <TableCell className='tableBodyCell'
                              >
                                {item.jobTitile}
                              </TableCell>
                              <TableCell className='tableBodyCell'
                              >
                                {item.event}
                              </TableCell>
                              <TableCell className='tableBodyCell'
                              >
                                {item.notes}
                              </TableCell>

                              <TableCell className='tableBodyCell'
                              >
                                {item.processedBy}
                              </TableCell>
                              <TableCell className='tableBodyCell' >
                                <Tooltip
                                  slotProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#0A0D12",
                                        borderRadius: '8px',
                                        padding: '8px 12px',
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                      }
                                    }
                                  }}
                                  title={item?.deletable ? "Delete" : ""}>
                                  <IconButton
                                    sx={{ color: item?.deletable && '#fd5c63' }}
                                    disabled={!item?.deletable}
                                    onClick={(e) => item?.deletable && hanldeMiniDialogOpen(item)}
                                  >
                                    <DeleteIcon
                                      stroke={item?.deletable ? 'red' : '#a2a2a2'}
                                      style={{ cursor: !item?.deletable && 'not-allowed', pointerEvents: 'auto' }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={10}>
                            <Typography className="emptydatas">No Data Found</Typography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )
                  ) : (
                    <TableCell colSpan={100}>
                      <Box className='tableloader'>
                        <TableLoader />
                      </Box>
                    </TableCell>
                  )
                }
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <MUICancelButton onClick={handleClose} title='Close'>Close</MUICancelButton>
          </DialogActions>
        </Dialog>
      </Grid2>

      {/* Add job dialog box */}
      <Grid2>
        <Dialog
          className="sidePopup"
          open={openpostions}
          onClose={handleClose}
          scroll="paper"
          maxWidth="md"
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>Select Position</Typography>
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClosePosition}></CloseIcon>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <TextField
                type="text"
                placeholder="Search by position"
                value={searchQuery}
                onChange={handleSearchChange}
                className="textfields1"
                style={{ width: '100%' }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position='start'>
                        <SearchIconLg width={20}></SearchIconLg>
                      </InputAdornment>
                    )
                  }
                }}
              />

              {/* Displaying filtered positions */}
              {/* <div>
                {filteredPositions?.length > 0 ? (
                  filteredPositions.map((position) => (
                    <Typography
                      key={position.positionId}
                      onChange={(event) => handleCheckboxChange(event, position.positionId)}
                      sx={{ fontSize: '14px', padding: '7px', cursor: 'pointer', color: '#414651' }}
                    >
                      <Checkbox
                        value={position.positionId}
                        checked={selectedPositionIds?.includes(position.positionId)}
                        sx={{
                          '& .MuiSvgIcon-root':
                          {
                            fontSize: 18,
                            width: '20px',
                            borderRadius: '1px'
                          },
                          '&.Mui-checked': {
                            color: '#7F56D9',

                          },
                          padding: 0.5,
                        }
                        }
                      />
                      {position?.listData}
                    </Typography>
                  ))
                ) : (
                  <Typography sx={{ color: '#D5D7DA' }}>No positions found</Typography>
                )}
              </div> */}

              <div style={{ marginTop: '10px' }}>
                {filteredPositions?.length > 0 ? (
                  filteredPositions?.map((position) => (
                    <Typography
                      key={position.positionId}
                      sx={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        color: '#414651',
                        borderRadius: '10px',
                        paddingTop: '10px'
                      }}
                    >
                      <label htmlFor={`checkbox-${position.positionId}`} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <Checkbox
                          id={`checkbox-${position.positionId}`}  // Set a unique id for the checkbox
                          value={position.positionId}
                          checked={selectedPositionIds?.includes(position.positionId)}
                          onChange={(event) => handleCheckboxChange(event, position.positionId)}
                          sx={{
                            '& .MuiSvgIcon-root': {
                              fontSize: 18,
                            },
                            padding: 0.5,
                            marginRight: '4px'
                          }}
                        />
                        {position?.listData}
                      </label>
                    </Typography>
                  ))
                ) : (
                  <Typography sx={{ color: '#414651', fontSize: '14px', justifyContent: 'center', display: 'flex' }}>No positions found</Typography>
                )}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <MUICancelButton onClick={handleClosePosition} sx={{ width: '42%' }} title='Close'>Close</MUICancelButton>
              <MuiButton onClick={assignPositions} title="Apply" sx={{ width: '42%' }}></MuiButton>
            </Grid2>
          </DialogActions>
        </Dialog>
      </Grid2>

      <Grid2 item>
        <Dialog
          open={filterDialogOpen}
          scroll="paper"
          maxWidth='md'
          className="sidePopup"
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '18px' }}>Filters</Typography>
            <CloseIcon onClick={() => setFilterDialogOpen(false)} sx={{ cursor: 'pointer' }} />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>

              <Grid2 container rowGap={2} sx={{ display: 'flex', width: '100%' }}>
                {/* Container 1 */}

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Address </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder="Search Address"
                    value={location || ""}
                    onChange={handleGetLocation}
                  />
                </Box>

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Technologies </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder="Search technologies"
                    value={technologies || ""}
                    onChange={handleTechnologies}
                  />
                </Box>


                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Mobile </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder=" search Mobile"
                    value={mobile || ""}
                    onChange={handleMobile}
                  />
                </Box>

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Email </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder='sreach by email'
                    value={email}
                    onChange={handleEmail}

                  />
                </Box>

                <Box sx={{ width: '100%', }}>
                  <InputLabel className="input">From Date</InputLabel>
                  <MuiDatePicker
                    slotProps={{
                      textField: {
                        placeholder: 'From Date',
                      },
                    }}
                    value={fromDate || null}
                    onChange={hanldeFromDate}
                  />

                  {/* <DatePicker selected={startDate} onChange={(date) => setStartDate(date)}>
                    <div style={{ color: "red" }}>Don't forget to check the weather!</div>
                    <button>Button</button>
                  </DatePicker> */}

                </Box>
                <Box sx={{ width: '100%' }}>
                  <InputLabel className="input">To Date</InputLabel>
                  <MuiDatePicker
                    slotProps={{
                      textField: {
                        placeholder: 'To Date',
                      },
                    }}
                    value={toDate || null}
                    onChange={handleTodate}
                    minDate={getNextDay(fromDate) || null}
                    disableOpenPicker={!fromDate}
                    disabled={!fromDate}
                  />
                </Box>


                <Box sx={{ width: '100%' }}>
                  <InputLabel className="input"> Sourced By </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder=" search Sourced By"
                    value={sourcedBy || ""}
                    onChange={handleSourcedBy}
                  />
                </Box>

              </Grid2>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <MUICancelButton title='close' sx={{ width: '42%' }} onClick={handleCloseFilterDialog} />
              <MuiButton title='Apply'
                sx={{ width: '42%' }}
                onClick={letsFilterDatas}
              />
            </Grid2>
          </DialogActions>
        </Dialog>

        <Grid2 item>
          <Dialog
            open={MinihistoryDialogOpen}
            scroll="paper"
            maxWidth="xs"
            sx={{
              "& .MuiDialog-paper": {
                width: '90%',
                maxWidth: '550px',
                height: 'auto',
                borderRadius: '15px'
              },
            }}
          >
            <DialogContent>
              <DialogContentText>
                <div style={{ display: 'flex', gap: '12px', marginTop: '7px' }}>
                  <div style={{ backgroundColor: '#FEE4E2', borderRadius: '40px', height: '40px', width: '45px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <DeleteIcon stroke={'red'} />
                  </div>

                  <div>
                    <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '17px' }}>Delete Job?</Typography>
                    <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>
                      Are you sure you want to delete this post? This action cannot be undone.
                    </Typography>
                  </div>
                </div>
                <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <MUICancelButton title='Cancel' onClick={() => setMinihistoryDialogOpen(false)} />
                  <MUIButton title='Delete' sx={{ backgroundColor: '#D92D20', borderRadius: '10px', cursor: 'pointer' }} onClick={deleteEventHistory} />
                </Grid2>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Grid2>
      </Grid2>
    </Box >
  )
}
export default CandidateReferrals;